import { createSlice } from '@reduxjs/toolkit';

interface CommonState {
  common_loading: boolean;
  user: Record<string, any> | null;
}

const initialState: CommonState = {
  common_loading: false,
  user: null,
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setCommonLoading: (state, action) => {
      state.common_loading = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
    },
  },
});

export const { setCommonLoading, setUser, clearUser } = commonSlice.actions;

export default commonSlice.reducer;
